export default {
  fixation: '固定',
  fluid: '流式',
  globalStyleSetting: '整体风格设置',
  darkStyle: '暗色菜单风格',
  lightStyle: '亮色菜单风格',
  theme: '主题色',
  navigationMode: '导航模式',
  sidebarNavigater: '侧边栏导航',
  topNavigater: '顶部栏导航',
  onlyValid: '该设定仅 [顶部栏导航] 时有效',
  contentWidth: '内容区域宽度',
  fixHeader: '固定 Header',
  configurableWhenFixingHeaders: '固定 Header 时可配置',
  hideHeaders: '下滑时隐藏 Header',
  fixedSideMenu: '固定侧边菜单',
  otherSettings: '其他设置',
  layoutSettings: '布局设置',
  colorBlindness: '色弱模式',
  grayMode: '黑白模式',
  multiTab: '多页签模式',
  copySettings: '拷贝设置',
  words:
    '配置的设置可以复制到defaultSettings.ts中作为项目的默认设置。修改配置文件后，需要清空本地缓存和LocalStorage',
  testFun: '试验功能',
  darkMode: '黑夜模式',
  contentArea: '内容区域'
}
